import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class iFrameDirectHireRoute extends Route {
  @service('commands/user-commands') userCommandService;

  async model({ freelancerId }) {
    const user = await this.userCommandService.getUser(freelancerId, ['location', 'profile', 'services']);
    return { user };
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/iframe/direct-hire');
  }
}

export default iFrameDirectHireRoute;
